export default __webpack_public_path__ + "static/summit_stars_4_9-2af793122570bfa682208ed6ac77b12c.svg";